<template>
    <div>
        <input type="text" :class="'form-control rounded '+(is_required ? 'requiredQuestion' : '')" ref="autocompleteInput" :value="currentValue" @input="currentValue = $event.target.value" />
        <input type="hidden" :name="name" :value="currentValue" />
    </div>
</template>

<script>
export default {
    props: {
        name: { type: String, required: true },
        value: { type: String, default: '' },
        is_required: { type: Boolean, default: false },
    },
    data() {
        return { currentValue: this.value };
    },
    mounted() {
        this.initAutocomplete();
    },
    methods: {
        initAutocomplete() {
            if (!window.google || !window.google.maps) {
                // Google not loaded yet — retry shortly
                setTimeout(() => this.initAutocomplete(), 300);
                return;
            }
            const { Autocomplete } = google.maps.places;
            const autocomplete = new Autocomplete(this.$refs.autocompleteInput, {
                fields: ['formatted_address', 'name'],
                types: ['geocode'],
            });
            autocomplete.addListener('place_changed', () => {
                const place = autocomplete.getPlace();
                this.currentValue = place.formatted_address || place.name || this.$refs.autocompleteInput.value;
            });
        },
    },
};
</script>
